"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterPromos = void 0;
var react_1 = require("react");
var date_fns_1 = require("date-fns");
var useFilterPromos = function (promotions) {
    return (0, react_1.useMemo)(function () {
        var resultPromos = {
            availablePromos: [],
            futurePromos: [],
        };
        if (!promotions)
            return resultPromos;
        promotions === null || promotions === void 0 ? void 0 : promotions.forEach(function (promo) {
            var _a, _b;
            if (((_a = promo === null || promo === void 0 ? void 0 : promo.activeDayOfWeek) === null || _a === void 0 ? void 0 : _a.length) &&
                ((_b = promo === null || promo === void 0 ? void 0 : promo.activeDayOfWeek) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                var activeDayOfWeek = promo.activeDayOfWeek;
                // const nearestDayOfWeek =
                //   getNearestActiveWeekDayFromArray(activeDayOfWeek);
                // if (checkPromoDay([nearestDayOfWeek]).active)
                //   resultPromos.availablePromos.push(promo);
                // else resultPromos.futurePromos.push(promo);
            }
            if (promo.dateStart && promo.dateEnd) {
                var dateStart = promo.dateStart, dateEnd = promo.dateEnd;
                var isAfterStart = dateStart && (0, date_fns_1.isAfter)(new Date(), new Date(dateStart * 1000));
                var isBeforeEnd = dateEnd && (0, date_fns_1.isBefore)(new Date(), new Date(dateEnd * 1000));
                if (isAfterStart && isBeforeEnd) {
                    resultPromos.availablePromos.push(promo);
                }
                else if (!isAfterStart) {
                    resultPromos.futurePromos.push(promo);
                }
            }
        });
        return resultPromos;
    }, [promotions]);
};
exports.useFilterPromos = useFilterPromos;
